import React, { Component } from "react";
import Img from 'gatsby-image';
import Link from 'gatsby-link';
import $ from 'jquery';
import { slugify } from '../components/slugify';
import BackgroundImage from 'react-background-image-loader';
import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

var BaseHref = 'http://46.4.51.11:1337'




const ArbeitsgebietePage = ({ data }) => (


    <div>

        <div className="row">
            <div className="col-xs-12 col-md-4 col-lg-4 accordion-container">
                <h1>Wir erbringen folgende <nobr>Leistungen …</nobr></h1>

                <Accordion>
                    {data.allStrapiLeistungen.edges.map((document) => {
                        return (
                            <AccordionItem key={"ag1" + document.node.id}>
                                <AccordionItemTitle>
                                    <div className="title">
                                        {document.node.Title}
                                    </div>
                                    <div className="more" />
                                </AccordionItemTitle>
                                <AccordionItemBody>
                                    <div dangerouslySetInnerHTML={{ __html: document.node.Leistungen_details }} />
                                </AccordionItemBody>
                            </AccordionItem>
                        )
                    })
                    }
                </Accordion>
            </div>



            <div className="col-xs-12 col-md-8 col-lg-8" style={{ backgroundColor: 'transparent' }}>

                {/* <!-- first row --> */}
                <div className="row bottom-xs first-row" style={{ backgroundColor: '#fff' }}>

                    <Link 
                    className="col-md-6 col-xs-12 tiles tunnel" 
                    to={`/leistungen-arbeitsgebiete/${slugify(data.allStrapiArbeitsgebiete.edges[0].node.Title)}`}
                    style={{
                        background : 'url('+ data.tunnelbau.edges[0].node.publicURL +')',
                        backgroundSize : 'cover'
                    }}
                    >
                        <div>
                            <div className="row bottom-xs">
                                <div className="col-xs-10">
                                    {data.allStrapiArbeitsgebiete.edges[0].node.Title}
                                </div>
                                <div className="col-xs-2 more">

                                </div>
                            </div>
                        </div>
                    </Link>


                    <div className="col-md-6 col-xs-12 tiles intro" style={{ backgroundColor: '#F47F24' }}>
                        <div style={{ padding: '20px' }}>
                            <h1 style={{ color: '#fff', float: 'right', textAlign: 'right' }}> … auf diesen Arbeitsgebieten </h1>
                        </div>
                    </div>
                </div>
                {/* <!-- end first row --> */}
                {/* <!-- second row --> */}
                <div className="row bottom-xs" style={{ backgroundColor: '#fff' }}>
                    <Link 
                    className="col-md-6 col-xs-12 tiles energie" 
                    to={`/leistungen-arbeitsgebiete/${slugify(data.allStrapiArbeitsgebiete.edges[5].node.Title)}`}
                    style={{
                        background: 'url(' + data.energie.edges[0].node.publicURL + ')',
                        backgroundSize: 'cover',
                        backgroundPositionY: '40%'
                    }}
                    >
                        <div>

                            <div className="row bottom-xs">
                                <div className="col-xs-10">
                                    {data.allStrapiArbeitsgebiete.edges[5].node.Title}
                                </div>
                                <div className="col-xs-2 more">

                                </div>
                            </div>
                        </div>
                    </Link>
                    <Link 
                    className="col-md-3 col-xs-12 tiles verkehr" 
                    to={`/leistungen-arbeitsgebiete/${slugify(data.allStrapiArbeitsgebiete.edges[6].node.Title)}`}
                    style={{
                        background: 'url(' + data.verkehr.edges[0].node.publicURL + ')',
                        backgroundSize: 'cover'
                    }}
                    >
                        <div>

                            <div className="row bottom-xs">
                                <div className="col-xs-10">
                                    {data.allStrapiArbeitsgebiete.edges[6].node.Title}
                                </div>
                                <div className="col-xs-2 more">

                                </div>
                            </div>
                        </div>
                    </Link>
                    <Link 
                    className="col-md-3 col-xs-12 tiles kampfmittel" 
                    to={`/leistungen-arbeitsgebiete/${slugify(data.allStrapiArbeitsgebiete.edges[2].node.Title)}`}
                    style={{
                        background: 'url(' + data.kampfmittel.edges[0].node.publicURL + ')',
                        backgroundSize: 'cover',
                        backgroundPositionX: '50%'
                    }}
                    >
                        <div>

                            <div className="row bottom-xs">
                                <div className="col-xs-10">
                                    {data.allStrapiArbeitsgebiete.edges[2].node.Title}
                                </div>
                                <div className="col-xs-2 more">

                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
                {/* <!-- seccond row --> */}
                {/* <!-- third row --> */}
                <div className="row bottom-xs" style={{ backgroundColor: '#fff' }}>
                    <Link 
                    className="col-md-3 col-xs-12 tiles schulung" 
                    to={`/leistungen-arbeitsgebiete/${slugify(data.allStrapiArbeitsgebiete.edges[1].node.Title)}`}
                    style={{
                        background: 'url(' + data.schulung.edges[0].node.publicURL + ')',
                        backgroundSize: 'cover',
                        backgroundPositionX: '20%'
                    }}
                    >
                        <div>

                            <div className="row bottom-xs">
                                <div className="col-xs-10">
                                    {data.allStrapiArbeitsgebiete.edges[1].node.Title}
                                </div>
                                <div className="col-xs-2 more">

                                </div>
                            </div>
                        </div>
                    </Link>

                    <Link 
                    className="col-md-3 col-xs-12 tiles geotechnik" 
                    to={`/leistungen-arbeitsgebiete/${slugify(data.allStrapiArbeitsgebiete.edges[3].node.Title)}`}
                    style={{
                        background: 'url(' + data.geotechnik.edges[0].node.publicURL + ')',
                        backgroundSize: 'cover',
                        backgroundPositionX: '-20%'
                    }}    
                    >
                        <div>
                            <div className="row bottom-xs">
                                <div className="col-xs-10">
                                    {data.allStrapiArbeitsgebiete.edges[3].node.Title}
                                </div>
                                <div className="col-xs-2 more">

                                </div>
                            </div>
                        </div>
                    </Link>

                    <Link 
                    className="col-md-6 col-xs-12 tiles wasserbau" 
                    to={`/leistungen-arbeitsgebiete/${slugify(data.allStrapiArbeitsgebiete.edges[4].node.Title)}`}
                    style={{
                        background: 'url(' + data.wasserbau.edges[0].node.publicURL + ')',
                        backgroundSize: 'cover'
                    }}
                    >
                        <div>

                            <div className="row bottom-xs">
                                <div className="col-xs-10">
                                    {data.allStrapiArbeitsgebiete.edges[4].node.Title}
                                </div>
                                <div className="col-xs-2 more">

                                </div>
                            </div>

                            <div>

                            </div>
                        </div>
                    </Link>

                </div>

            </div>

        </div>

    </div>



)



export default ArbeitsgebietePage;


export const LeistungenArbeitsgebieteQuery = graphql`  
  query Arbeitsgebiet {
     tunnelbau: allFile(filter: {id: { regex:"/img_tunnelbau@2x/"} }){
        edges{
            node{
                publicURL
            }
        }
    },
     energie: allFile(filter: {id: { regex:"/img_energie/"} }){
        edges{
            node{
                publicURL
            }
        }
    },
      geotechnik: allFile(filter: {id: { regex:"/img_geotechnik@2x/"} }){
        edges{
            node{
                publicURL
            }
        }
    },
      kampfmittel: allFile(filter: {id: { regex:"/img_kampfmittel@2x/"} }){
        edges{
            node{
                publicURL
            }
        }
    },
      schulung: allFile(filter: {id: { regex:"/img_schulung@2x/"} }){
        edges{
            node{
                publicURL
            }
        }
    },
      verkehr: allFile(filter: {id: { regex:"/img_verkehr@2x/"} }){
        edges{
            node{
                publicURL
            }
        }
    },
      wasserbau: allFile(filter: {id: { regex:"/img_wasserbau/"} }){
        edges{
            node{
                publicURL
            }
        }
    },
    allStrapiArbeitsgebiete {
      edges {
        node {
            id
            Title
            Arbeitsgebiet_Detail_Text
            Arbeitsgebiet_Detail_List
            Arbeitsgebiete_Image{
                    childImageSharp{
                    sizes {
                    base64
                    tracedSVG
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                    originalImg
                    originalName
                    }
                }
            }
        }
      }
    },
        allStrapiLeistungen{
            edges {
                node {
                    id
                    Title
                    Leistungen_details
                }
            }
        }
    }
`



// WEBPACK FOOTER //
// ./src/pages/leistungen-arbeitsgebiete.js